<template>
  <div class="form-group">
    <div :class="hasIcon(icon)">
      <span v-if="iconDir === 'left'" class="input-group-text">
        <i :class="getIcon(icon)"></i>
      </span>
      <input
        :id="id"
        :type="type"
        class="form-control text-lg"
        :class="getClasses(size, success, error)"
        :name="name"
        :value="inputValue"
        :placeholder="placeholder"
        :required="isRequired"
        :disabled="disabled"
        @input="updateValue($event.target.value)"
      />
      <span v-if="iconDir === 'right'" class="input-group-text">
        <i :class="getIcon(icon)"></i>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "SoftInput",
  props: {
    // Compatibility props
    value: [String, Number], // Vue 2
    modelValue: [String, Number], // Vue 3

    // Other props
    size: {
      type: String,
      default: "default",
    },
    success: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: "",
    },
    iconDir: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
    id: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "Type here...",
    },
    type: {
      type: String,
      default: "text",
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    // Handles both v-model (Vue 3) and value (Vue 2)
    inputValue() {
      return this.modelValue !== undefined ? this.modelValue : this.value;
    },
  },
  methods: {
    updateValue(val) {
      // Vue 3
      if (this.modelValue !== undefined) {
        this.$emit("update:modelValue", val);
      }
      // Vue 2
      if (this.value !== undefined) {
        this.$emit("input", val);
      }
    },
    getClasses(size, success, error) {
      const sizeValue = size ? `form-control-${size}` : "";
      const validationClass = error ? "is-invalid" : success ? "is-valid" : "";
      return `${sizeValue} ${validationClass}`;
    },
    getIcon(icon) {
      return icon || null;
    },
    hasIcon(icon) {
      return icon ? "input-group" : null;
    },
  },
};
</script>
